import { combineReducers } from 'redux'
import { REDUCER_NAME } from './const'
import { reducer as detailReducer, REDUCER_NAME as DETAIL_REDUCER_NAME } from './detail'
import { reducer as listReducer, REDUCER_NAME as LIST_REDUCER_NAME } from './search'


const reducer = combineReducers({
    [LIST_REDUCER_NAME]: listReducer,
    [DETAIL_REDUCER_NAME]: detailReducer,
})

export {
    reducer,
    REDUCER_NAME,
}



// WEBPACK FOOTER //
// ./src/modules/prospect/state/index.js